import { Controller } from "@hotwired/stimulus"

// Progressive disclosure for the Serientermin section of the appointment form.
//
// Hidden inputs are also disabled, not just hidden: a disabled input is not submitted, so
// the controller never has to guess whether "ends_on" was meant when the user had picked
// "never", and an ordinary appointment posts no recurrence params at all.
export default class extends Controller {
  // The interval units ("Wochen", "Monate", ...) come from the view rather than living
  // here, so the translations stay in config/locales.
  static values = { units: Object }

  static targets = [
    "toggle",
    "panel",
    "frequency",
    "weekdays",
    "intervalUnit",
    "endsOn",
    "occurrenceCount",
  ]

  connect() {
    this.syncFrequency()
    this.syncPanel()
  }

  toggle() {
    this.syncPanel()
  }

  frequencyChanged() {
    this.syncFrequency()
  }

  endsModeChanged() {
    const mode = this.selectedEndsMode()
    if (this.hasEndsOnTarget) this.setEnabled(this.endsOnTarget, mode === "on_date")
    if (this.hasOccurrenceCountTarget)
      this.setEnabled(this.occurrenceCountTarget, mode === "after_count")
  }

  // The end-date control is a wrapper around the date picker's visible input, its hidden
  // companion and its calendar trigger — all three have to follow the radio.
  setEnabled(element, enabled) {
    element
      .querySelectorAll("input, select, button")
      .forEach((field) => (field.disabled = !enabled))
  }

  syncPanel() {
    if (!this.hasPanelTarget || !this.hasToggleTarget) return

    const on = this.toggleTarget.checked
    this.panelTarget.classList.toggle("hidden", !on)
    this.panelTarget
      .querySelectorAll("input, select, button")
      .forEach((field) => (field.disabled = !on))

    // Re-apply the end-condition rules, which disable more than the toggle does.
    if (on) this.endsModeChanged()
  }

  syncFrequency() {
    if (!this.hasFrequencyTarget) return

    const frequency = this.frequencyTarget.value
    if (this.hasWeekdaysTarget)
      this.weekdaysTarget.classList.toggle("hidden", frequency !== "weekly")
    if (this.hasIntervalUnitTarget)
      this.intervalUnitTarget.textContent = this.unitsValue[frequency] || ""
  }

  selectedEndsMode() {
    const checked = this.element.querySelector("input[name='recurrence[ends_mode]']:checked")
    return checked ? checked.value : "never"
  }
}
